const RegisterPage = () => {
  return <h1>Register Page</h1>;
};

export default RegisterPage;
